<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import './sub/inputStyle.css'

    const dispatch = createEventDispatcher();

    export let name;
    export let inputType = "text";
    export let val: any = "";
    export let required = false;
    export let placeholder = "";
    export let autoFocus = false;

    const ERROR_ENUM = Object.freeze({
        NONE: 0,
        OTHER: 1,
        REQUIRED: 2,
    });

    export let nativeInput = null;
    $: if (autoFocus && nativeInput) nativeInput.focus();
    let errorBackgrounClass = "underlineColor errBackgorund";
    let errType = ERROR_ENUM.NONE;
    setTimeout(updateInputState, 1); // mabye not show errors

    /* $: {
        if (!inputElm || !inputElm.value) {
            console.log('rm')
            labelIsUpClass = "";
        } else {
            console.log('add')
            console.log(inputElm)
            labelIsUpClass = "labelUp";
        }
    } */
    // $: placeholder, updateInputState(null);
    $: {
        placeholder;
        updateInputState();
    }
    // not aptimalized, TO DO
    let labelIsUp = false;
    function updateInputState() {
        if (nativeInput && (nativeInput.value || placeholder)) {
            labelIsUp = true;
        } else {
            labelIsUp = false
        }

        if (!nativeInput || nativeInput.validity.valid) {
            errorBackgrounClass = "underlineColor errBackgorund";
            errType = ERROR_ENUM.NONE;
        } else {
            errorBackgrounClass =
                "underlineColor errBackgorund errBackgorundActive";
            if (nativeInput.validity.valueMissing) {
                errType = ERROR_ENUM.REQUIRED;
            } else {
                errType = ERROR_ENUM.OTHER;
            }
        }
    }
    function handleKeyup(event) {
        if (event.code === "Enter" || event.code === "NumpadEnter") {
            event.preventDefault();
            dispatch("enter", {
                text: val,
            });
        }
    }
</script>

<div class="root">
    <div class="textBlock">
        <!-- svelte-ignore a11y-label-has-associated-control -->
            <span class="standartLabel" class:inputLabelUp={labelIsUp}>{name}</span>
            <!-- <input
            bind:this={inputElm}
            on:input={updateUnputState}
            on:blur={updateUnputState}
            type={inputType}
            {required}
        /> -->
            {#if inputType === "text"}
                <input
                    class="inputRectangle"
                    bind:this={nativeInput}
                    bind:value={val}
                    {placeholder}
                    on:input={updateInputState}
                    on:blur={updateInputState}
                    on:keyup|preventDefault={handleKeyup}
                    type="text"
                    {required}
                />
            {/if}
            {#if inputType === "password"}
                <input
                    class="inputRectangle"
                    bind:this={nativeInput}
                    bind:value={val}
                    {placeholder}
                    on:input={updateInputState}
                    on:blur={updateInputState}
                    on:keyup|preventDefault={handleKeyup}
                    type="password"
                    {required}
                />
            {/if}
            {#if inputType === "number"}
                <input
                    class="inputRectangle"
                    bind:this={nativeInput}
                    bind:value={val}
                    {placeholder}
                    on:input={updateInputState}
                    on:blur={updateInputState}
                    on:keyup|preventDefault={handleKeyup}
                    type="number"
                    step="any"
                    {required}
                />
            {/if}
        <div class="underline">
            <div class="underlineColor focusColorLine" />
            <div class={errorBackgrounClass} />
        </div>
    </div>
    {#if errType === ERROR_ENUM.REQUIRED}
        <div class="errorBlock">
            <!-- transition:fade={{ duration: 400 }} -->
            <p>
                Pole je <strong>povinné</strong>.
            </p>
        </div>
    {/if}
    {#if errType === ERROR_ENUM.OTHER}
        <div class="errorBlock">
            <!-- transition:fade={{ duration: 400 }} -->
            <p>Nespecifikovaný error.</p>
        </div>
    {/if}
</div>

<style>
    .root {
        /* padding: 0.2rem 2rem 1rem 2rem; */
        box-sizing: border-box;
        background: var(--back);
        display: flex;
        flex-direction: column;
    }
    .standartLabel {
        align-self: start;
        margin: 0 0.5rem;
        bottom: -1.7rem;
    }
    .focusColorLine {
        background: var(--prim);
    }
    .errBackgorund {
        background: var(--err);
    }

    .errBackgorundActive {
        width: 100%;
    }
   
    /* .text:focus-within .standartLabel {
        bottom: -0.55rem;
        transition: all cubic-bezier(0.17, 0.67, 0.21, 2) 0.3s;
    }
    .labelUp .standartLabel {
        bottom: -0.55rem;
        transition: all cubic-bezier(0.17, 0.67, 0.21, 2) 0.3s;
    } */

    ::placeholder {
        opacity: 0.7;
    }
</style>
